var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$data.$_enableCarousel
    ? _c(
        "a",
        {
          staticClass: "owl-carousel owl-theme",
          attrs: {
            id: "owl-carousel-" + _vm._uid,
            href: _vm.itemUrl,
            "aria-label": _vm.$translate("Ceres::Template.itemImageCarousel"),
            role: "listbox"
          }
        },
        _vm._l(_vm.imageUrls, function(imageUrl, index) {
          return _c(
            "div",
            { key: index },
            [
              _c("lazy-img", {
                ref: { itemLazyImage: index === 0 },
                refInFor: true,
                attrs: {
                  "image-url": imageUrl.url,
                  alt: _vm.getAltText(imageUrl),
                  title: _vm.getTitleText(imageUrl),
                  width: _vm.getImageWidth(imageUrl),
                  height: _vm.getImageHeight(imageUrl),
                  "picture-class": "img-fluid",
                  role: "option"
                }
              })
            ],
            1
          )
        }),
        0
      )
    : _c(
        "a",
        {
          attrs: {
            href: _vm.itemUrl,
            "aria-label": _vm.getAltText(_vm.imageUrls[0])
          }
        },
        [
          _c("lazy-img", {
            ref: { itemLazyImage: !_vm.disableLazyLoad },
            attrs: {
              "image-url": _vm.imageOrItemImage,
              alt: _vm.getAltText(_vm.imageUrls[0]),
              title: _vm.getTitleText(_vm.imageUrls[0]),
              width: _vm.getImageWidth(_vm.imageUrls[0]),
              height: _vm.getImageHeight(_vm.imageUrls[0]),
              "picture-class": "img-fluid"
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }